import React from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import logo from '../../images/logo.png'

const Header = () => {
    //Active header styles
    const activeStyle = {
        fontWeight: "bold",
        color: "orange"
    }
    return (
        //Adding navbar on header
        <Navbar bg="white" variant="light" className="mb-5">
            <Container className="d-flex mb-5">
                {/*Adding logo on header*/}
                <Navbar.Brand href="#home">
                    <img
                        src={logo}
                        width="350"
                        height="75"
                        className="d-inline-block align-top"
                        alt="english baksho logo"
                    />
                </Navbar.Brand>
                {/*Adding navbar tabs*/}
                <Nav className="me-auto">
                    <NavLink className="text-decoration-none link-dark  me-5" to="/home" activeStyle={activeStyle}>Home</NavLink>
                    <NavLink className="text-decoration-none link-dark  me-5" to="/services" activeStyle={activeStyle}>Services</NavLink>
                    <NavLink className="text-decoration-none link-dark  me-5" to="/instructors" activeStyle={activeStyle}>Instructors</NavLink>
                    <NavLink className="text-decoration-none link-dark  me-5" to="/about" activeStyle={activeStyle}>About</NavLink>
                </Nav>
            </Container>
        </Navbar>
    );
};

export default Header;